import './TextInputWrapper-77cbfa23.css';

var styles = {"TextInputBaseWrapper":"prc-components-TextInputBaseWrapper-ueK9q","TextInputWrapper":"prc-components-TextInputWrapper-i1ofR"};

export { styles as default };
